import axios from 'axios';

export interface ProductRequest {
  city: string;
  comment: string;
  email: string;
  firstName: string;
  lastName: string;
  phone: string;
  productId: string;
  requestType: string | null;
  productUrl: string;
  salutationDisplayName: 'Herr' | 'Frau' | 'Keine Angabe';
  street: string;
  zipCode: string;
  assistantData?: Record<string, unknown>;
}

export interface ProductRequestData {
  shopHost: string;
  shopApiKey: string;
  shopUseBasicAuth: boolean;
  shopBasicAuth?: string;
  productRequest: ProductRequest;
  s3BucketName?: string;
  s3FileAttachmentPaths?: Array<string>;
}

const S3_REGION = 'eu-central-1';

export const sendProductRequest = async (
  productRequestData: ProductRequestData,
): Promise<void> => {
  try {
    const {
      productRequest,
      shopHost,
      shopApiKey,
      shopUseBasicAuth,
      shopBasicAuth,
      s3BucketName,
      s3FileAttachmentPaths,
    } = productRequestData;

    const headers: Record<string, string> = {
      'sw-access-key': shopApiKey,
    };
    if (shopUseBasicAuth) {
      headers.authorization = `Basic ${shopBasicAuth}`;
    }

    let attachments: Array<{
      bucket: string;
      file: string;
      region: string;
    }> = [];
    if (
      s3BucketName &&
      s3FileAttachmentPaths &&
      s3FileAttachmentPaths.length > 0
    ) {
      attachments = s3FileAttachmentPaths.map((attachmentPath) => ({
        bucket: s3BucketName,
        file: attachmentPath,
        region: S3_REGION,
      }));
    }

    await axios.post(
      `${shopHost}/store-api/gj/product-request`,
      {
        ...productRequest,
        attachments,
      },
      { headers },
    );
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
    throw new Error('An error occurred while sending the product request.');
  }
};
